import { render, staticRenderFns } from "./MesasSalaoConfigForm.vue?vue&type=template&id=0d270b5e&scoped=true"
import script from "./MesasSalaoConfigForm.vue?vue&type=script&lang=js"
export * from "./MesasSalaoConfigForm.vue?vue&type=script&lang=js"
import style0 from "./MesasSalaoConfigForm.vue?vue&type=style&index=0&id=0d270b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d270b5e",
  null
  
)

export default component.exports